import React, { useState } from "react";
import { Trash2 } from "lucide-react";

const PRESET_PREFIXES = ["app", "contact", "newsroom", "advertise", "tips", "info", "hello", "press", "support"];

/** Configured routing addresses with per-row delete. */
export function AddressList({ addresses, busy, onRemove }) {
  return (
    <div className="border border-zinc-800 rounded-sm">
      <div className="px-4 py-3 border-b border-zinc-800 label-tiny">Configured addresses</div>
      <div className="divide-y divide-zinc-800">
        {addresses.length === 0 && <div className="px-4 py-6 text-sm text-zinc-500">No specific addresses yet — add some below or rely on catch-all.</div>}
        {addresses.map((a) => (
          <div key={a.id} className="px-4 py-2.5 flex items-center gap-3">
            <span className={`dot ${a.enabled ? "bg-emerald-500" : "bg-zinc-600"}`} />
            <div className="mono text-sm flex-1">{a.address}</div>
            <div className="mono text-xs text-zinc-500">→ {(a.forwards_to || []).join(", ")}</div>
            <button onClick={() => onRemove(a.id)} disabled={busy} className="text-zinc-500 hover:text-red-400 disabled:opacity-40"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}

/** Preset prefix chips + custom prefix input. `onAdd(prefix)` resolves true on success. */
export function AddAddressCard({ site, addresses, busy, onAdd }) {
  const [custom, setCustom] = useState("");
  const used = new Set(addresses.map((a) => (a.address || "").split("@")[0]));
  const presets = PRESET_PREFIXES.filter((p) => !used.has(p));

  async function addCustom() {
    if (await onAdd(custom)) setCustom("");
  }

  return (
    <div className="border border-zinc-800 bg-zinc-900/40 rounded-sm p-5">
      <div className="label-tiny mb-3">Add address</div>
      {presets.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-3">
          {presets.map((p) => (
            <button key={p} onClick={() => onAdd(p)} disabled={busy} className="text-xs mono px-2.5 py-1 border border-zinc-700 hover:border-white hover:text-white text-zinc-300 rounded-sm disabled:opacity-50">+ {p}@</button>
          ))}
        </div>
      )}
      <div className="flex gap-2">
        <div className="flex items-center bg-zinc-950 border border-zinc-800 rounded-sm">
          <input type="text" value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="custom" className="admin-input bg-transparent border-0 px-3 py-2 text-sm mono outline-none w-40" />
          <span className="mono text-zinc-500 text-sm pr-3">@{site.domain}</span>
        </div>
        <button onClick={addCustom} disabled={busy || !custom} className="bg-white text-zinc-950 hover:bg-zinc-200 disabled:opacity-50 px-4 py-2 rounded-sm text-sm font-semibold">Add</button>
      </div>
    </div>
  );
}
